<tt-page *ngIf="!!edit">
    <div class="col-xs-12 sp-0 height-full" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="editFields"></ng-container>
        </tt-card>

        <tt-grid *ngIf="!!grid" class="flex-1" [(ttOptions)]="grid"></tt-grid>
    </div>

    <div class="height-full" *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="timestampstartcorr_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="30">
                    <tt-card>
                        <ng-container *ngTemplateOutlet="editFields"></ng-container>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="70">
                    <tt-grid *ngIf="!!grid" class="flex-1" [(ttOptions)]="grid"></tt-grid>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>

<ng-template #editFields>
    <ng-container *ngIf="!!edit">
        <tt-input ttLabel="labour_no" [ttModel]="edit.labour_no" ttReadonly></tt-input>
        <tt-input ttLabel="labour_name" [ttModel]="edit.labour_name" ttReadonly></tt-input>
        <tt-datetime ttLabel="timestamp_start" [(ttModel)]="edit.timestamp_start" (ttModelChange)="onChanged($event, 'timestamp_start')"></tt-datetime>
        <tt-checkbox ttLabel="force_timestamp_end" [(ttModel)]="edit.force_timestamp_end"></tt-checkbox>
        <tt-datetime [hidden]="edit.force_timestamp_end !== '1'" ttLabel="timestamp_end" [(ttModel)]="edit.timestamp_end" (ttModelChange)="onChanged($event, 'timestamp_end')"></tt-datetime>
        <tt-button-save ttText="timestampstartcorr_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </ng-container>
</ng-template>
